// Library Methods
import { useEffect } from "react";
import { useTranslation } from "react-i18next";

// Styles
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";

// Components
import Typography from "@mui/material/Typography";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import IconButton from "@mui/material/IconButton";
import { CloseIcon } from "src/assets/icons";

type OperatingManualNavModalType = {
  isOpen: boolean;
  onClose: () => void;
  children: React.ReactNode;
};

const OperatingManualNavModal = ({
  isOpen,
  onClose,
  children,
}: OperatingManualNavModalType) => {
  const { t } = useTranslation("operating-manual");

  const theme = useTheme();
  const largerThanMd = useMediaQuery(theme.breakpoints.up("md"));

  useEffect(() => {
    if (largerThanMd) onClose();
  }, [largerThanMd, onClose]);

  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
      fullScreen
      fullWidth
      PaperProps={{
        sx: {
          ...(theme.palette.mode === "dark" && {
            backgroundColor: "#5C6076",
            backgroundImage: "none",
          }),
        },
      }}
    >
      <DialogTitle
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          backgroundColor: "#202338",
          color: "#FFF",
        }}
      >
        <Typography fontWeight={600} fontSize="16px">
          {t("Index")}
        </Typography>
        <IconButton aria-label="close-modal" color="inherit" onClick={onClose}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent sx={{ padding: 0 }}>{children}</DialogContent>
    </Dialog>
  );
};

export default OperatingManualNavModal;
